




























import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { ProvisionFieldTypes } from "@/data/enums/provisioning";

// Types
import { IBlueprintField, IAttributeList } from "@/models/provisioning";

@Component({
  components: {
    "provision-field": () =>
      import(
        "@/components/app/admin/catalogue/products/provisioning/provisionField.vue"
      ),
    "attribute-multi-value": () =>
      import(
        "@/components/app/admin/catalogue/products/provisioning/attributeMultiValue.vue"
      )
  }
})
export default class ManageAttributesList extends Vue {
  @Prop({ required: true })
  public value!: IAttributeList;

  @Prop({ required: true })
  public attributes!: IBlueprintField[];

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ required: true })
  public fieldValues!: IBlueprintField;

  public provisionFieldTypes = ProvisionFieldTypes;

  public get formValues() {
    return this.value;
  }

  public set formValues(values) {
    this.$emit("input", values);
  }
}
